import { render, staticRenderFns } from "./ClientProposalFillPage.vue?vue&type=template&id=b03faa9c&scoped=true"
import script from "./ClientProposalFillPage.vue?vue&type=script&lang=js"
export * from "./ClientProposalFillPage.vue?vue&type=script&lang=js"
import style0 from "./ClientProposalFillPage.vue?vue&type=style&index=0&id=b03faa9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03faa9c",
  null
  
)

export default component.exports